'use client';

import { HamburgerMenuIcon } from '@/_assets/icon-components';
import Logo from '@/_components/Logo';
import { onOpenMap } from '@/_store/common/common.slice';
import { mapDesktopLog } from '@/_components/Map/mapDesktopLog';
import { IRedux } from '@/_store/types';
import { usePathname } from '@/i18n/navigation';
import {
  HStack,
  IconButton,
} from '@chakra-ui/react';
import { XIcon } from 'lucide-react';
import React, { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import BrandSelect from './_components/BrandSelect';
import CartPopover from './_components/CartPopover';
import DeliveryType from './_components/DeliveryType';
import Drawer from './_components/Drawer';
import Languages from './_components/Languages';
import Search from './_components/Search';
import User from './_components/User';
import RestaurantSearch from '@/app/[locale]/(universal)/brand/_components/Search';

interface HeaderDesktopProps {
  brandLogo?: string | null;
}

const HeaderDesktop: React.FC<HeaderDesktopProps> = ({ brandLogo }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const pathname = usePathname();

  const { is_hall } = useSelector((state: IRedux) => state.session);
  const dispatch = useDispatch();

  const handleToggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleOpenMap = () => {
    mapDesktopLog('1 header-openBranches', { is_hall });
    dispatch(onOpenMap());
  };

  const isBrandPage = pathname.slice(0, pathname.lastIndexOf('/')) === '/brand';
  return (
    <>
      <HStack
        justify='space-between'
        px={14}
        gap={3}
        py={4}
        borderBottom={'1px solid #F3F3F3'}
      >
        <HStack gap={6}>
          <HStack gap={3}>
            <IconButton
              onClick={handleToggleDrawer}
              rounded={'full'}
              variant='ghost'
              color='text'
            >
              {isDrawerOpen ? <XIcon /> : <HamburgerMenuIcon />}
            </IconButton>
            {/* <HStack separator={brandLogo ? <StackSeparator /> : undefined} gap={4}> */}
            <HStack gap={4}>
              <Logo />
              {/* <BrandSelect brandLogo={brandLogo} /> */}
            </HStack>
          </HStack>
          <HStack gap={2}>
            {isBrandPage ? <RestaurantSearch /> : <Search />}
            {is_hall !== 'true' && (
              <DeliveryType handleOpenMap={handleOpenMap} />
            )}
          </HStack>
        </HStack>
        <HStack gap={3}>
          <Languages />
          <CartPopover />
          <User />
        </HStack>
      </HStack>
      <Drawer open={isDrawerOpen} setOpen={setIsDrawerOpen} />
    </>
  );
};

export default memo(HeaderDesktop);
